import { render, staticRenderFns } from "./ViewFooter.vue?vue&type=template&id=9cdaf12e&"
import script from "./ViewFooter.vue?vue&type=script&lang=js&"
export * from "./ViewFooter.vue?vue&type=script&lang=js&"
import style0 from "./ViewFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports